import authorsPageRequest from "./includes/authorsPageRequest";

let sort = function() {
    let authors = [...document.querySelectorAll('#author-list div.authors__list-item')];
    const authorsContainer = document.querySelector('#author-list');
    if(!authorsContainer) return;

    let _authors = [];
    let locale = document.querySelector('html').lang;

    authors.forEach(e => {
        let title = e.querySelector('div.author-info a.base-color').textContent.trim();
        let initials = title.split(' ');
        let last_key = initials.length - 1;
        let surname = initials[last_key].replace(',', '');
        if(surname) {
            let author = {
                surname: surname,
                layout: e,
            };
            _authors.push(author);
        }
    });



    if(_authors) {
        _authors.sort((a, b) => {
            return a.surname.localeCompare(b.surname, locale);
        });

        if(!authorsContainer) return;

        authorsContainer.innerHTML = '';

        _authors.forEach(e => {
            authorsContainer.appendChild(e.layout);
        });
    }

}
let init = function() {
    const alphabetLetters = [...document.querySelectorAll('li.alphabet-item')];

    alphabetLetters.forEach(e => {
        e.addEventListener('click', sort);
        if(e.querySelector('input').checked) e.checked = false;
    });

    let firstLetter = document.querySelector('li.alphabet-item');

    if(firstLetter) {
        let input = firstLetter.querySelector('input');

        if(input) {
            input.checked = true;
        }
        let letter = firstLetter.querySelector('span').textContent;
        let response = authorsPageRequest(letter).then(result => {
            if(result) {
                let wrapper = document.createElement('div');
                wrapper.classList.add('posts-wrapper' , 'authors__list--full', 'd-flex' , 'flex-column' , 'flex-md-row', 'flex-wrap');
                wrapper.id = 'author-list';

                for(let i in result) {
                    let authorTemplate = getAuthorTemplate(result[i]);
                    wrapper.appendChild(authorTemplate);
                }

                let $authorList = document.querySelector('#author-list');
                $authorList.replaceWith(wrapper);
            }
        });
    }
}

/**
 * @param {object} authorData
 *
 */
function getAuthorTemplate(authorData) {
    console.log(authorData);

    let container = document.createElement('div');
    const containerClassList = ['authors__list-item', 'd-flex'];
    containerClassList.forEach(e => container.classList.add(e));

    let imageWrapper = document.createElement('div');
    imageWrapper.classList.add('author-image-wrapper');

    let image = document.createElement('img');
    image.src = authorData._embedded["wp:featuredmedia"][0]['source_url'] ?? '';
    image.width = 222;
    image.height = 222;

    imageWrapper.appendChild(image);

    let infoWrapper = document.createElement('div');
    infoWrapper.classList.add('author-info', 'd-flex', 'flex-column');

    const link = document.createElement('a');
    link.href = authorData.link ?? '';
    link.classList.add('base-color');
    link.textContent = authorData.title.rendered ?? '';

    const span = document.createElement('span');
    span.textContent = stripHtml(authorData.excerpt.rendered ?? '');

    infoWrapper.appendChild(link);
    infoWrapper.appendChild(span);

    container.appendChild(imageWrapper);
    container.appendChild(infoWrapper);

    return container;
}

/**
 * Returns the text from a HTML string
 *
 * @param html The html string
 */
function stripHtml(html){
    // Create a new div element
    const temporalDivElement = document.createElement("div");
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = html;
    // Retrieve the text property of the element (cross-browser support)
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
}


document.addEventListener('AuthorsRenderEvent', sort);
document.addEventListener('DOMContentLoaded', () => {
    init();
    document.dispatchEvent(window.authorsPageEvent);
});